import React from 'react';
import styled from 'styled-components';
import { translate } from 'base/shared/Localization';

const Container = styled.div`
  background-color: #283618;
  border-radius: 1.5rem;
  padding: 3rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 4rem 0;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 2rem;
    text-align: center;
    padding: 1.5rem;
    margin: 2rem;
  }
`;

const TextContent = styled.div`
  flex: 1;
`;

const Title = styled.h2`
  font-size: 1.5rem;
  font-weight: 400;
  color: #ffffff;
  margin: 0;
  line-height: 1.2;

  @media (max-width: 768px) {
    font-size: 1.25rem;
  }

  @media (max-width: 480px) {
    font-size: 1rem;
  }
`;

const CTAButton = styled.button`
  background-color: #ffffff;
  color: #283618;
  border: none;
  border-radius: 0.75rem;
  padding: 1rem 1.5rem;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;

  &:hover {
    background-color: #f9fafb;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  &:active {
    transform: translateY(0);
  }

  @media (max-width: 768px) {
    width: 100%;
    max-width: 300px;
  }
`;

export default function CTABanner() {
  const handleContactClick = () => {
    window.open('https://badiplus.typeform.com/homepageform', '_blank');
  };

  return (
    <Container>
      <TextContent>
        <Title>
          {translate('v2.contactSalesBanner.text')}
          <br />
        </Title>
      </TextContent>

      <CTAButton onClick={handleContactClick}>
        {' '}
        {translate('v2.contactSalesBanner.button')}
      </CTAButton>
    </Container>
  );
}
